import { SetStateAction, useEffect, useState } from 'react';

import { InputField, UseTextInputFieldReturnType } from '../Form/InputField';
import { Assets } from '../../assets';
import { Button } from '../Button';
import { Text } from '../Text';

export const SearchInputField = ({
  searchQueryInput,
  placeholder,
  isInitiallyMinified = false,
}: {
  searchQueryInput: UseTextInputFieldReturnType;

  isInitiallyMinified?: boolean;
  setIsMinified?: React.Dispatch<SetStateAction<boolean>>;
  placeholder: string;
}) => {
  const clearInput = () => {
    searchQueryInput.setValue('');
  };

  const [isMinified, setIsMinified] = useState(isInitiallyMinified);

  const handleOnClick = () => {
    if (setIsMinified) {
      setIsMinified(!isMinified);
    }
  };

  useEffect(() => {
    if (isInitiallyMinified) {
      setIsMinified(true);
    } else {
      setIsMinified(false);
    }
  }, [isInitiallyMinified]);

  if (isMinified) {
    return (
      <Button styleAs="link" onClick={handleOnClick}>
        <Text color="foraBlue">Sök</Text> <Assets.MagnifyingGlassIcon color="foraBlue" marginLeft={7} width={14} />
      </Button>
    );
  }
  return (
    <InputField
      isSearch
      type="text"
      id="search-input-field"
      label={placeholder}
      icon={<Assets.MagnifyingGlassIcon marginRight={12} />}
      clearInput={clearInput}
      {...searchQueryInput.props}
      hideLabel
      placeholder={placeholder}
    />
  );
};
